module.exports = __webpack_public_path__ + "img/ho.987d0105.jpg";